<section class="simple-select">
	<div class="simple-select-caption" (click)="fnAccionSimpleSelect( $event )">
		<p><span>{{ fnGetCaption() }}</span></p>
		<p><i class="fas fa-caret-down"></i></p>
	</div>
	<div class="simple-select-content animated fadeIn">
		<section  *ngIf="!mostrarBuscador">
			<div class="control">
				<input class="txtbuscar" type="text" placeholder="Buscar" [(ngModel)]="txtBuscar">
			</div>
			<div (click)="fnBorrarBusqueda()">
				<p>
					<span *ngIf=" txtBuscar !== '' "><i class="fas fa-times"></i></span>
					<span *ngIf=" txtBuscar === '' "><i class="fas fa-search"></i></span>
				</p>
			</div>
		</section>
		<div (click)="fnSeleccionItem( newItem )" class="simple-select-content-items" *ngFor="let newItem of listaElementos | filter:'nombre':txtBuscar">
			<p>{{ newItem.nombre }}</p>
		</div>
	</div>
</section>
<style type="text/css">
	.simple-select-content > section{
		width: 100%;
		height: 60px;
		padding: 0px 5px;
		display: flex;
		align-items: center;
		border-bottom: #ccc solid 1px;

		position: -webkit-sticky;
		position: sticky;
		top: 0;
		background-color: white;
	}
	.simple-select-content > section > div,
	.simple-select-content > section > div > input{
		margin: 0px;
		height: 40px;
	}
	.simple-select-content > section > div:first-child{
		width: calc( 100% - 50px );
	}
	.simple-select-content > section > div:last-child{
		width: 50px;
		display: flex;
		cursor: pointer;
		align-items: center;
		border: #ccc solid 1px;
	}
	.simple-select-content > section > div:last-child > p{
		width: 100%;
		text-align: center;
	}
</style>